import { useState, useEffect } from 'react';
import toMessageText from '../../../../components/messageText';
import { useGeneralEvolutions } from './useGeneralEvolutions';

// Orquestração da lista de evoluções gerais (web e mobile): mensagens, menu de ações e modais.
export function useGeneralEvolutionListScreen(patientId) {
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const [showErrorMessage, setShowErrorMessage] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const [isEvolutionModalOpen, setEvolutionModalOpen] = useState(false);
  const [isHistoryModalOpen, setHistoryModalOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedEvolution, setSelectedEvolution] = useState(null);
  const [evolutionToRectify, setEvolutionToRectify] = useState(null);

  const { evolutions, isLoading, error: listError, refetch } = useGeneralEvolutions(patientId);

  useEffect(() => {
    if (listError) {
      setShowErrorMessage(true);
      setErrorMessage(toMessageText(listError, 'Ocorreu um erro ao carregar as evoluções.'));
    }
  }, [listError]);

  const openAddModal = () => {
    setEvolutionToRectify(null);
    setEvolutionModalOpen(true);
  };

  const openActionsMenu = (event, evolution) => {
    setAnchorEl(event.currentTarget);
    setSelectedEvolution(evolution);
  };

  const closeActionsMenu = () => {
    setAnchorEl(null);
  };

  const openRectifyModal = () => {
    setEvolutionToRectify(selectedEvolution);
    setEvolutionModalOpen(true);
    closeActionsMenu();
  };

  const openHistoryModal = () => {
    setHistoryModalOpen(true);
    closeActionsMenu();
  };

  const closeEvolutionModal = () => {
    setEvolutionModalOpen(false);
    setEvolutionToRectify(null);
  };

  const closeHistoryModal = () => {
    setHistoryModalOpen(false);
  };

  const onEvolutionSaved = (returnFromApi) => {
    if (returnFromApi.data) {
      setShowSuccessMessage(true);
      setSuccessMessage(toMessageText(returnFromApi.data));
    } else {
      setShowErrorMessage(true);
      setErrorMessage(toMessageText(returnFromApi.response?.data));
    }
    closeEvolutionModal();
    refetch();
  };

  return {
    evolutions,
    isLoading,
    showSuccessMessage,
    setShowSuccessMessage,
    successMessage,
    showErrorMessage,
    setShowErrorMessage,
    errorMessage,
    isEvolutionModalOpen,
    isHistoryModalOpen,
    anchorEl,
    selectedEvolution,
    evolutionToRectify,
    openAddModal,
    openActionsMenu,
    closeActionsMenu,
    openRectifyModal,
    openHistoryModal,
    closeEvolutionModal,
    closeHistoryModal,
    onEvolutionSaved,
  };
}
